import React from 'react';
import Ripple from '../Ripple';


module.exports = (props) => {
  const children = props.children || null;
  return (
    <Ripple
      {...props}
      className={`layoutRow fhaS fvaC h34 ph15 bg0.25 r7 bg06:h z1 rlv ov usN
        cDADCE1 dn fw5 f14 ff$2 ` + (props.className || '')}
    >
      {children}
    </Ripple>
  );
};
